import { LocalizationFieldType } from '../graphql/generated/graphql.ts';

/**
 * A Lokalisation's extra field as it was recorded. The value is stored dot-separated - that is what
 * HL7 NM and the number input both need - so every read-only rendering swaps the separator instead.
 */
export const germanDecimal = (value: string, inputType: LocalizationFieldType): string =>
  inputType === LocalizationFieldType.NUMBER ? value.replace('.', ',') : value;
